export interface ServiceData {
  title: string
  description: string
  pricing: string
  metadata: {
    title: string
    description: string
  }
}

export const servicesData: Record<string, ServiceData> = {
  'ai-visibility-strategy': {
    title: 'AI Visibility Strategy',
    description:
      'GEO, AEO, and LLM optimization. Get cited by ChatGPT, Claude, Perplexity, and Gemini.',
    pricing: 'From $4,500',
    metadata: {
      title: 'AI Visibility Strategy | GEO and AEO',
      description:
        'Get cited by ChatGPT, Claude, Perplexity, and Gemini. We audit and fix your AI search visibility using Radar. Sprint + retainer.',
    },
  },
  'ai-product-development': {
    title: 'AI Product Development',
    description:
      'Build AI products or add AI to existing ones, from validation to production in 90 days. You own the code.',
    pricing: 'From $4,995',
    metadata: {
      title: 'AI Product Development | Ship in 90 Days',
      description:
        'Build AI products or add AI to existing ones. From validation to production in 90 days. You own the application code.',
    },
  },
  'revenue-first-design': {
    title: 'Brand & Sales Design',
    description:
      'Brand identity, design systems, pitch decks, and sales collateral for SaaS teams, shipped as one system.',
    pricing: 'From $1,995',
    metadata: {
      title: 'Brand & Sales Design | SaaS Design Systems',
      description:
        'Brand identity, design systems, pitch decks, and sales collateral for SaaS teams. From $1,995.',
    },
  },
  'ai-powered-growth': {
    title: 'Growth Marketing',
    description:
      'Pipeline generation for B2B SaaS. Content, lead scoring, email automation, and analytics on a retainer.',
    pricing: 'From $2,995/mo',
    metadata: {
      title: 'Growth Marketing for B2B SaaS',
      description:
        'Pipeline generation for B2B SaaS. Content, lead scoring, email automation, analytics. Retainers from $2,995/mo.',
    },
  },
}

export function getServiceData(slug: string): ServiceData | null {
  return servicesData[slug] || null
}
